// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_gnu","content":"styles_content__qrDBN"};